import isLocalStorageAvailable from './mini/isLocalStorageAvailable';

const SwitchGitHubPromoPlanPopupManager = {

    markOpenForFuture: (email) => {
        if (isLocalStorageAvailable() && email) {
            localStorage.setItem(`switch-gh-popup-was-opened-${email}`, 1);
        }
    },

    markClosedForFuture: (email) => {
        if (isLocalStorageAvailable() && email) {
            localStorage.removeItem(`switch-gh-popup-was-opened-${email}`);
        }
    },

    shouldBeOpend: (email) => {
        if (isLocalStorageAvailable() && email) {
            return localStorage.getItem(`switch-gh-popup-was-opened-${email}`);
        }
        return false;
    },

};
export default SwitchGitHubPromoPlanPopupManager;